export default "__VITE_ASSET__8ySMm3Yt__"